module.exports = __webpack_public_path__ + "img/img22-b.4de64176.svg";